import {
  getPermittedMarketAccountsSet,
  type GetPermittedMarketAccountsSetParams,
} from '@src/hooks/usePermittedMarketAccountsSet';
import { MarketAccountStatusEnum } from '@talos/kyoko';

type SubAccountEligibilityParams = Omit<
  GetPermittedMarketAccountsSetParams,
  'subAccountAllocations' | 'combineAllMarketAccounts'
>;

/**
 * True when the sub account has Write access to at least one active market account.
 * Wildcards count all active accounts; unloaded or Read-only mappings count as none.
 */
export function isEligibleTransferFilterSubAccount(
  subAccountName: string,
  params: SubAccountEligibilityParams
): boolean {
  const activeMarketAccountsList = params.marketAccountsList.filter(ma => ma.Status === MarketAccountStatusEnum.Active);
  const permittedMarketAccountNames = getPermittedMarketAccountsSet({
    ...params,
    marketAccountsList: activeMarketAccountsList,
    subAccountAllocations: [{ subAccount: subAccountName, value: '1' }],
  });
  return permittedMarketAccountNames != null && permittedMarketAccountNames.size >= 1;
}
